<template>
    <div class="date-picker-container">
      <div class="filter">
        <vue-datepicker-local
          v-on:input="emitDateSelected"
          :value="selected"
          :disabledDate="disabledDate"
          :local="local"
          :type="type"
          :popup-class="type === 'inline' ? 'force-inline' : ''"
          :format="formatDate" />
      </div>
    </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import VueDatepickerLocal from 'vue-datepicker-local';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import {mapGetters} from 'vuex';

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    formatDate: {
      type: String,
      default: 'YYYY'
    },
    startDate: {
      type: String
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false;
      }
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  components: {
    FontAwesomeIcon,
    VueDatepickerLocal
  },
  data () {
    return {
      selected: [new Date(this.startDate), new Date()]
    };
  },
  watch: {
    value (val) {
      this.selected = val;
    }
  },
  created () {
    dayjs.extend(localeData);
    dayjs.localeData();
  },
  methods: {
    emitDateSelected (payload) {
      this.selected = payload;
      this.$emit('input', payload);
    },
    getMonths () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const months = dayjs.months();
      return months.map(month => this.capitalize(month));
    },
    getMonthsShort () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const months = dayjs.monthsShort();
      return months.map(month => this.removeLastCharacter(this.capitalize(month)));
    },
    getWeekDays () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const days = dayjs.weekdaysShort(true);
      return days.map(day => this.removeLastCharacter(this.capitalize(day)));
    },
    capitalize (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    },
    removeLastCharacter (str) {
      return str.substring(0, str.length - 1);
    }
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    local () {
      return {
        dow: this.getLanguageCode === 'es' ? 1 : 0,
        hourTip: this.$t('filter.hour'), // tip of select hour
        minuteTip: this.$t('filter.minute'), // tip of select minute
        secondTip: this.$t('filter.second'), // tip of select second
        yearSuffix: '', // suffix of head year
        monthsHead: this.getMonths(), // months of head
        months: this.getMonthsShort(), // months of panel
        weeks: this.getWeekDays(), // weeks
        cancelTip: this.$t('filter.cancel'),
        submitTip: this.$t('filter.submit')
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables.scss";

.date-picker-container {
  width: fit-content;
}

.filter {
  @media (max-width: $screen-l-max) {
    width: 100%;
    margin-bottom: $sp;
  }
}
.filter-date {
  background-color: $black-trans7;
  border: 1px solid $white-trans6;
  border-radius: $radius;
  color: $white;
  width: 100%;
  [controlsBg="light"] & {
    color: $bodycolor;
    background-color: $white;
    border: 1px solid $black-trans6;
  }
}

.topbar-dropdown {
  color: $bodycolor-inverse;
  margin-left: $sp;
  font-weight: 800;
  [controlsBg="light"] & {
    color: $bodycolor;
  }

  svg {
    margin-left: $sp-margin-smaller;
    transform: scale(0.875);
    transform-origin: bottom;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/DateRangePicker.vue